<template>
  <v-select
    :label="label ? label : 'Employee Type'"
    :items="employeeTypeList"
    v-model="employeeTypeValue"
    item-text="employeeType"
    item-value="id"
    :rules="[requiredCheck()]"
    :disabled='disabled'
    outlined
  ></v-select>
</template>

<script>
import { mapActions } from 'vuex'
import { mapFields } from '@/vueHelpers/vuex'
import { required } from '@/lib/formValidations'

export default {
  props: [
    'isRequired',
    'employeeType',
    'disabled',
    'label'
  ],
  computed: {
    ...mapFields('employeeTypes', [
      'employeeTypeList'
    ]),
    employeeTypeValue: {
      get () {
        return this.employeeType
      },
      set (newValue) {
        this.$emit('employee-type-change', newValue)
      }
    }
  },
  created () {
    this.getEmployeeTypes()
  },
  methods: {
    ...mapActions('employeeTypes', [
      'getEmployeeTypes'
    ]),
    requiredCheck () {
      return !this.isRequired || required('Employee type')
    }
  }
}
</script>
